export enum AnimState {
    None,

    Search,
    SearchToCourts,
    SearchToPlayers,
    SearchToCalendarProgress,
    SearchToCalendar,
    SearchToFilter,

    SearchCalendar,
    SearchCalendarToSearchProgress,
    SearchCalendarToSearch,

    Courts,
    CourtsToSearch,
    CourtsToPlayers,
    CourtsToCalendarProgress,
    CourtsToCalendar,
    CourtsToFilter,

    CourtsCalendar,
    CourtsCalendarToCourtsProgress,
    CourtsCalendarToCourts,

    Players,
    PLayersPlayersToPlayers,
    PLayersPlayersToPlayersBack,
    PLayersPlayersToCourts,
    PlayersPlayersToCalendarProgress,
    PlayersPlayersToCalendar,
    PlayersPlayersToFilter,
    PlayersCourtsToCourts,
    PlayersCourtsToFilter,

    PlayersPlayersCalendarToPlayersPlayersProgress,
    PlayersPlayersCalendarToPlayersPlayers,
}
